import './spinner.css'

const Spinner = () => {
  return (
    <div
      style={{
        display: 'flex',
        margin: '0 auto',
        marginTop: '250px',
        textAlign: 'center',
        flexDirection: 'column',
      }}
    >
      <div>
        <h2>
          <a
            href="https://makeresume.co"
            target="_blank"
            rel="noreferrer"
            title="Go to makeresume.co"
            className="link-home"
          >
            makeresume.co
          </a>
        </h2>
      </div>
      <div className="lds-facebook-big">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>
        <span className="loading-message">loading</span>
      </div>
    </div>
  )
}

export default Spinner
